module.exports = __webpack_public_path__ + "static/media/appleid_button@2x.6203815d.png";